export default "__VITE_ASSET__CTAp1Egn__"